// extracted by mini-css-extract-plugin
module.exports = {"container":"Watch_container__sIlik","fadeIn":"Watch_fadeIn__XmMN0"};